export default "__VITE_ASSET__BPXfZrNk__"